module.exports = __webpack_public_path__ + "static/media/ico-btn-instation.90f348e5.svg";